import * as api from '../../services/luckydraw'

export const FETCH_DRAWPOOL= 'FETCH_DRAWPOOL';
export const FETCH_WINNERSBYPAGE = 'FETCH_WINNERSBYPAGE';
export const FETCH_ROLLPOOL = 'FETCH_ROLLPOOL';
export const FETCH_ROLLPOOLS = 'FETCH_ROLLPOOLS';
export const FETCH_ADMIN_ROLLPOOLS = 'FETCH_ADMIN_ROLLPOOLS';
export const FETCH_ATTENDEEWINNERS = 'FETCH_ATTENDEEWINNERS';
export const FETCH_ROLLPOOLBWLISTS = 'FETCH_ROLLPOOLBWLISTS';
export const FETCH_DRAWPOOLBWLISTS = 'FETCH_DRAWPOOLBWLISTS';


export const fetchDrawpool= (params, pagination, sort, extra) => {
    return {
        type: FETCH_DRAWPOOL,
        payload: {
            promise: api.findDrawpool(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}

export const fetchWinnersByPage= (params, pagination, sort, extra) => {
    return {
        type: FETCH_WINNERSBYPAGE,
        payload: {
            promise: api.findWinnersByPage(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}

export const fetchAttendeeWinners= (params, pagination, sort, extra) => {
    return {
        type: FETCH_ATTENDEEWINNERS,
        payload: {
            promise: api.findAttendeeWinners(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}

//
export const fetchRollpool= (params, pagination, sort, extra) => {
    return {
        type: FETCH_ROLLPOOL,
        payload: {
            promise: api.findRollpool(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}
export const fetchRollpools= (params, pagination, sort, extra) => {
    return {
        type: FETCH_ROLLPOOLS,
        payload: {
            promise: api.findRollpools(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}
export const fetchAdminRollpools = (params, pagination, sort, extra) => {
    return {
        type: FETCH_ADMIN_ROLLPOOLS,
        payload: {
            promise: api.fetchAdminRollpools(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}

//黑白名单
export const fetchRollpoolBwLists= (params, pagination, sort, extra) => {
    return {
        type: FETCH_ROLLPOOLBWLISTS,
        payload: {
            promise: api.findRollpoolBwLists(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}

export const fetchDrawpoolBwLists= (params, pagination, sort, extra) => {
    return {
        type: FETCH_DRAWPOOLBWLISTS,
        payload: {
            promise: api.findDrawpoolBwLists(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/luckydraw.js